import { render, staticRenderFns } from "./FinanceReqBody.vue?vue&type=template&id=2776ff22"
import script from "./FinanceReqBody.vue?vue&type=script&lang=js"
export * from "./FinanceReqBody.vue?vue&type=script&lang=js"
import style0 from "./FinanceReqBody.vue?vue&type=style&index=0&id=2776ff22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports